export default __webpack_public_path__ + "static/media/11.e02f3b80.jpg";